import { LiveTopic } from '../../live-topics-types';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { LiveTopicNavigation } from './LiveTopicNavigation';
import { useLiveTopicNavigation } from './useLiveTopicNavigation';

const goToMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.goTo',
  defaultMessage: 'Ir',
});

/**
 * Actions for the live topic detail: "Ir" (go to time), play, and prev/next topic navigation.
 */
export function LiveTopicActions({
  topic,
  topics,
  onSelectTopic,
}: {
  topic: LiveTopic;
  topics: LiveTopic[];
  onSelectTopic: (id: string) => void;
}) {
  const { $t } = useIntl();
  const { handleGoTo, handlePlay } = useLiveTopicNavigation({ topic });

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Tooltip title={$t(goToMessage)}>
        <IconButton size="small" color="secondary" onClick={handleGoTo}>
          <LocationSearchingIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      {handlePlay && (
        <IconButton size="small" color="secondary" onClick={handlePlay}>
          <PlayCircleOutlineRoundedIcon fontSize="inherit" />
        </IconButton>
      )}
      <LiveTopicNavigation topic={topic} topics={topics} onSelectTopic={onSelectTopic} />
    </Stack>
  );
}
